/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import TriFloorPlan from "./TriFloorPlan.js";
import TriFloorPlanSkeleton from "./TriFloorPlanSkeleton.js";
import TriFloorPlanAPI from "./api/TriFloorPlanAPI.js";
import TriDropablePlugin from "./plugins/TriDropablePlugin.js";
import TriFloorPlanPlugin from "./plugins/TriFloorPlanPlugin.js";
import TriZoomPlugin from "./plugins/TriZoomPlugin.js";
import TriPanPlugin from "./plugins/TriPanPlugin.js";
import TriNavPlugin from "./plugins/TriNavPlugin.js";
import TriLastPositionPlugin from "./plugins/TriLastPositionPlugin.js";
import TriLabelsPlugin from "./plugins/TriLabelsPlugin.js";
import TriLayersPlugin from "./plugins/TriLayersPlugin.js";
import TriSelectablePlugin from "./plugins/TriSelectablePlugin.js";
import TriHighlightPlugin from "./plugins/TriHighlightPlugin.js";
import TriPinPlugin from "./plugins/TriPinPlugin.js";

import TriFloorPlanRegistry from "./plugins/TriFloorPlanRegistry";

export {
  TriFloorPlan,
  TriFloorPlanSkeleton,
  TriFloorPlanAPI,
  TriFloorPlanPlugin,
  TriDropablePlugin,
  TriZoomPlugin,
  TriPanPlugin,
  TriNavPlugin,
  TriLastPositionPlugin,
  TriLabelsPlugin,
  TriLayersPlugin,
  TriSelectablePlugin,
  TriHighlightPlugin,
  TriPinPlugin,
  TriFloorPlanRegistry,
};
